export const GAUGE_VIEWBOX = { width: 100, height: 80 };
export const GAUGE_RADIUS = 45;
export const GAUGE_CENTRE = { x: 50, y: 62 };

const HALF_SWEEP = (75 * Math.PI) / 180;
const TICK_OVERHANG = 5;

export const gaugePoint = (fraction: number, radius: number) => {
  const angle = -HALF_SWEEP + fraction * 2 * HALF_SWEEP;

  return {
    x: GAUGE_CENTRE.x + radius * Math.sin(angle),
    y: GAUGE_CENTRE.y - radius * Math.cos(angle),
  };
};

const arcStart = gaugePoint(0, GAUGE_RADIUS);
const arcEnd = gaugePoint(1, GAUGE_RADIUS);

// eslint-disable-next-line no-restricted-syntax -- an SVG path, not text
export const GAUGE_ARC = `M ${arcStart.x.toFixed(2)} ${arcStart.y.toFixed(2)} A ${GAUGE_RADIUS} ${GAUGE_RADIUS} 0 0 1 ${arcEnd.x.toFixed(2)} ${arcEnd.y.toFixed(2)}`;

export const gaugeTickPoints = (fraction: number) => {
  const inner = gaugePoint(fraction, GAUGE_RADIUS - TICK_OVERHANG);
  const outer = gaugePoint(fraction, GAUGE_RADIUS + TICK_OVERHANG);

  return { x1: inner.x, y1: inner.y, x2: outer.x, y2: outer.y };
};
